module.exports = __webpack_public_path__ + "static/media/settings.e0ae8173.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/settings.svg
// module id = 270
// module chunks = 0